module.exports = __webpack_public_path__ + "static/media/back-to-work.559cc385.png";